<template>
  <el-dialog :visible="showLookPic" :width="$route.path != '/customerRoom' ? '90%' : '530px'"
    :close-on-click-modal="false" @close="handleClose" title="重点录入字段">
    <div class="look-Entry-pic">
      <el-container v-if="$route.path != '/customerRoom'" class="left-table">
        <el-main style="padding: 0;">
          <el-table :data="importantFieldData"
            :header-cell-style="{ textAlign: 'center', color: '#333333', fontSize: '14px', fontWeight: 'bold', backgroundColor: '#FAFAFA' }"
            tooltip-effect="dark" ref="multipleTable" highlight-current-row>
            <el-table-column prop="standardFieldName" label="字段" align="center" show-overflow-tooltip>
            </el-table-column>
            <el-table-column label="备注" align="center" prop="fieldDescription" show-overflow-tooltip>
            </el-table-column>
            <el-table-column label="录入情况" align="center" prop="number">
            </el-table-column>
            <el-table-column label="单据样例" align="center">
              <template slot-scope="scope">
                <span v-if="scope.row.billDemo">
                  <el-button v-if="!scope.row.showFileInstance" type="text" size="small"
                    @click="clickFileInstance(scope.row, scope.$index)">查看</el-button>
                  <el-button v-else type="text" size="small" @click="foldUpInstance"
                    style="color: #FC691A">收起</el-button>
                </span>
              </template>
            </el-table-column>
          </el-table>
        </el-main>
        <el-footer>
          <el-pagination background :current-page="current" :page-sizes="[10, 20, 30, 50]" :page-size="size"
            layout="total, sizes, prev, pager, next, jumper" :total="total" @size-change="handleSizeChange"
            @current-change="handleCurrentChange" />
        </el-footer>
      </el-container>
      <div class="right-pic">
        <div class="right-title">查看图片</div>
        <div class="preview-imgs">
          <div v-if="selectImportantRow.showFileInstance" style="flex:1">
            <div class="instance-name">
              {{ selectImportantRow.standardFieldName }}-单据样例
            </div>
            <span class="fold-row" @click="foldUpInstance">
              <!-- <img src="@/assets/images/fold-left.png" alt=""/> -->
              <i class="el-icon-arrow-left"></i>
              <span>收起</span>
            </span>
            <MultipleOptionImg ref="instanceImgRef" :oneImg="false" :key="instanceTimer" :loadIndex="0"
              :otherList="picList1" :defaultIndex="defaultInstanceIndex" @changeInstanceArrow="changeInstanceArrow" />
          </div>
          <div style="flex:1">
            <div v-if="$route.path != '/customerRoom'" class="right-btns">
              <el-button round size="mini" @click="handleSetInvalid(true)">标为无效</el-button>
              <el-button round size="mini" @click="handleMarkFocus">加入录入</el-button>
            </div>
            <MultipleOptionImg ref="fileImgRef" :oneImg="false" :loadIndex="1" :otherList="picList"
              :defaultIndex="defaultAddImgIndex" @changeArrow="changeArrow">
              <el-button slot="button" v-if="$route.path == '/case'" size="mini"
                @click="sendToCurrentPatient">发送给当前患者</el-button>
            </MultipleOptionImg>
          </div>
        </div>
      </div>
    </div>
  </el-dialog>
</template>
<script>
import MultipleOptionImg from "@/components/MultipleOptionImg.vue";
import { DEEP_CLONE, leftRotate, rightRotate } from "@/utils/constants";
import { getPatientFocusFieldPage, disableInvalid, readOtherEntry, markFocus, pushPic } from "@/api/crossreentry"
export default {
  components: {
    MultipleOptionImg
  },
  props: {
    showLookPic: {
      type: Boolean,
      default: false
    },
    selectOtherFile: {
      type: Object,
      default: () => { }
    },
    newestList: {
      type: Object,
      default: () => { }
    }
  },
  data() {
    return {
      instanceTimer: 0,
      picList1: [],
      imgOss: process.env.VUE_APP_OSS_URL, //图片公用拼接地址
      // entryTableData: [],
      current: 1,
      size: 20,
      total: 0,
      importantFieldData: [],
      defaultAddImgIndex: 0,
      defaultInstanceIndex: 0,
      picList: [],
      selectImportantRow: {}
      // showFileInstance: false
    }
  },
  async created() {
    // console.log(this.selectOtherFile)
    this.picList = [].concat.apply([], Object.values(DEEP_CLONE(this.newestList))) // 转一维数组
    this.defaultAddImgIndex = this.picList.findIndex(item => {
      return item.url === this.selectOtherFile.url
    });
    this.getImportantField()
    this.markRead()
  },
  mounted() {
    // this.picList = [].concat.apply([],Object.values(DEEP_CLONE(this.newestList))) // 转一维数组
    // // console.log(this.picList)
    // // console.log(this.selectOtherFile)
    // this.$nextTick(() => {
    //   this.defaultAddImgIndex = this.picList.findIndex(item => {
    //     return item.url === this.selectOtherFile.url
    //   });
    //   // console.log(this.defaultAddImgIndex)
    //   // setTimeout(() => {
    //   //   this.$refs.carouselRef.setActiveItem(this.defaultAddImgIndex);
    //   // }, 0);
    // })
    // // console.log(this.defaultAddImgIndex)
    // // console.log(this.picList)
  },
  methods: {
    // 发送给当前患者
    async sendToCurrentPatient() {
      let res = await pushPic({
        patientFilesItemId: this.picList[this.defaultAddImgIndex].id,
        patientId: JSON.parse(sessionStorage.getItem("patientInfo")).patientId
      })
      if (res.code == 0) {
        this.$message.success('成功发送当前患者')
      } else {
        this.$message.error(res.msg)
      }
    },
    changeArrow(defaultAddImgIndex) {
      this.defaultAddImgIndex = defaultAddImgIndex
    },
    changeInstanceArrow(defaultAddImgIndex) {
      this.selectImportantRow.showFileInstance = false
      // console.log(this.$refs.instanceImgRef.defaultAddImgIndex)
      this.selectImportantRow = this.importantFieldData[defaultAddImgIndex]
      this.selectImportantRow.showFileInstance = true
    },
    foldUpInstance() {
      this.selectImportantRow.showFileInstance = false
    },
    // 查看样例
    clickFileInstance(row, index) {
      this.instanceTimer++
      this.defaultInstanceIndex = row.instanceIndex
      this.selectImportantRow.showFileInstance = false
      // this.picList1 = this.importantFieldData.map(v => v.billDemo)
      row.showFileInstance = true
      this.selectImportantRow = row
    },
    async handleMarkFocus() {
      let res = await markFocus({
        id: this.picList[this.defaultAddImgIndex].id,
        focus: true
      })
      if (res.code == 0) {
        this.$emit('closeLook', 1)
        // 刷新列表
      }
    },
    async markRead() {
      let res = await readOtherEntry({
        id: this.selectOtherFile.id
      })
      if (res.code == 0) {

      }
    },
    async handleSetInvalid(data) {
      let res = await disableInvalid(data, this.picList[this.defaultAddImgIndex].id)
      if (res.code == 0) {
        this.$message.success('成功')
        this.$emit('closeLook', 1)
      }
    },
    async getImportantField() {
      this.picList1 = []
      this.defaultInstanceIndex = 0
      this.selectImportantRow.showFileInstance = false
      this.selectImportantRow = {}
      let res = await getPatientFocusFieldPage({
        patientId: this.selectOtherFile.patientId,
        size: this.size,
        current: this.current
      })
      if (res.code == 0) {
        let instanceIndex = 0
        res.data.records.map((v, index) => {
          // if (index == 1) {
          //   v.billDemo = ''
          // }
          this.$set(v, 'showFileInstance', false)
          // console.log(index)
          if (v.billDemo) {
            this.picList1.push({
              url: v.billDemo,
              imgIndex: index
            })
            this.$set(v, 'instanceIndex', instanceIndex++)
          }
        })
        console.log(this.picList1)
        // this.selectImportantRow = res.data.records[0]
        // this.selectImportantRow.showFileInstance = true
        this.importantFieldData = res.data.records
        this.total = res.data.total
      }
    },
    handleSizeChange(val) {
      this.size = val
      this.getImportantField()
    },
    handleCurrentChange(val) {
      this.current = val
      this.getImportantField()
    },
    handleClose() {
      this.$emit('closeLook', 1)
    },
  }
};
</script>
<style lang="less" scoped>
.image-preview-mouse {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 490px;
  height: 420px;
  position: relative;
  /*定位*/
  // top: -20px;
  top: 0px;
  left: 0px;
}

.look-Entry-pic {
  display: flex;
  height: 75vh;
  overflow: hidden;

  .left-table {
    flex: 1;

    /deep/.el-pagination {
      text-align: right;
      padding-top: 20px;
    }
  }

  .right-pic {
    flex: 1;
    background: rgba(51, 51, 51, 0.85);
    padding: 36px 20px;
    overflow: scroll;

    .right-title {
      font-size: 16px;
      font-weight: 600;
      color: #FFFFFF;
      text-align: center;
      margin-bottom: 20px;
    }

    .right-btns {
      text-align: center;
      margin-bottom: 20px;

      .el-button {
        font-size: 12px;
        font-weight: 600;
        color: #000000;
      }
    }

    /deep/.el-carousel__container {
      height: 420px;
    }
  }
}

.preview-imgs {
  display: flex;

  .fold-row {
    // display: flex;
    // align-items: center;
    color: #FFFFFF;
    cursor: pointer;
    font-size: 16px;

    // img {
    //   width: 18px;
    //   height: 18px;
    // }
    span {
      line-height: 22px;
    }
  }
}

.instance-name {
  // margin-bottom:20px;
  line-height: 27px;
  font-size: 16px;
  font-weight: 600;
  color: #FFFFFF;
  text-align: center;
}
</style>
